import { KeyboardCode, ShortcutConfig } from "@/hooks/useKeyboardShortcut";

export type ShortcutMatchEvent = Pick<
  KeyboardEvent,
  "code" | "ctrlKey" | "altKey" | "shiftKey" | "metaKey"
>;

export function matchesShortcutConfig(
  event: ShortcutMatchEvent,
  config: ShortcutConfig
): boolean {
  const codeMatches = Array.isArray(config.code)
    ? config.code.includes(event.code as KeyboardCode)
    : event.code === config.code;

  return (
    codeMatches &&
    event.ctrlKey === Boolean(config.ctrlKey) &&
    event.altKey === Boolean(config.altKey) &&
    event.shiftKey === Boolean(config.shiftKey) &&
    event.metaKey === Boolean(config.metaKey)
  );
}
